import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

function LeftNav() {
  const { role } = useAuth();
  const navigate = useNavigate();
  const [selectedApp, setSelectedApp] = useState("SimplePermits"); // Default logo
  const [isFirstNavigation, setIsFirstNavigation] = useState(true);

  // Define logo based on selected app
  const getLogo = () => {
    switch (selectedApp) {
      case "SimplePermits":
        return `${process.env.PUBLIC_URL}/logo.svg`;  
      default:
        return `${process.env.PUBLIC_URL}/logo.svg`;
    }
  };

  const setApplicaton = () => {
    setSelectedApp("Default");
    setIsFirstNavigation(true);
  };;

  // Redirect to the child route when user selects an app
  useEffect(() => {
    if (role === "Admin") {
      if (selectedApp === "SimpleCheck") {
        navigate("/admin/simplecheck/application");
      } else if (selectedApp === "SimpleSpect") {
        navigate("/admin/simplespect/application");
      } else if (selectedApp === "SimplePermits" && isFirstNavigation) {
        navigate("/admin/applications");
        setIsFirstNavigation(false);
      } else if (selectedApp === "Default"){
        navigate("/admin/dashboard");
      }
    }
  }, [selectedApp, navigate, role, isFirstNavigation]);

  return (
    <aside className="sidebar text-center">
      {/* Dynamic Logo */}
      <img src={getLogo()} alt="Logo" className="admin-logo mb-3 mt-2" />

      <nav className="menu">
        {role === "Admin" && (
          <>
            {/* Default Links */}
            {selectedApp === "Permits" && (
              <>
                <NavLink to="/admin/applications" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/Home.svg`} alt="" className="px-2" />
                  Applications
                </NavLink>
                <hr />
                <NavLink to="/admin/invoices" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/Pie-Chart.svg`} alt="" className="px-2" />
                  Billing and Invoice
                </NavLink>
                <hr />
              </>
            )}

            {/* SimpleCheck */}
            {selectedApp === "Default" && (
              <>
               <div className="menu-item main-link" onClick={() => setSelectedApp("SimplePermits")} style={{ cursor: "pointer" }}>
                <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="" className="px-2" style={{ maxWidth: "50px" }} />
                Permits
              </div>
              </>
            )}

            {/* Show menus when SimpleCheck is selected */}
            {selectedApp === "SimpleCheck" && (
              <>
                <NavLink to="/admin/simplecheck/application" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/application.svg`} alt="" className="px-2" />
                  Plan Review Request
                </NavLink>
              </>
            )}

            {selectedApp === "SimpleSpect" && (
              <>
                <NavLink to="/admin/simplespect/application" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/application.svg`} alt="" className="px-2" />
                  Inspection Request
                </NavLink>
              </>
            )}
          </>
        )}
      </nav>

      {/* Back Button to Return to Default */}
      {selectedApp !== "Default" && (
        <button className="btn btn-outline-secondary mt-3" onClick={() => setApplicaton()}>
          Back to Main Panel
        </button>
      )}
    </aside>
  );
}

export default LeftNav;
